// Translation: Account > Members > Members list > Invitation dialog (Russian)
export default Object.freeze({
	actions: {
		cancel: '',
		invite: ''
	},
	fields: {
		email: {
			label: '',
			placeholder: ''
		},
		role: {
			label: ''
		}
	},
	title: ''
})
